/*
 * @fileOverView Quarantine component definition
 */

import Vue from 'vue';

/**
 * A reference to the classes used in this view
 *
 * @property CLASSES
 * @type {Object}
 * @private
 */
const CLASSES = {
  'WRAPPER': 'tableWrapper',
  'WRAPPER_SCROLLER': 'tableWrapper-scroller',
  'WRAPPER_SCROLLABLE_LEFT': 'tableWrapper_scrollableLeft',
  'WRAPPER_SCROLLABLE_RIGHT': 'tableWrapper_scrollableRight'
};

/**
 * [Quarantine Vue]
 * @type {class}
 */
Vue.component('quarantine-vue', {
  data: function() {
    return {
      tables: null
    }
  },

  mounted() {
    this.tables = this.$el.querySelectorAll('table');

    if (!this.tables || this.tables.length < 1) {
      return;
    }

    this.tables.forEach((table, idx) => {
      const $table = $(table);
      const id = `table-${idx}`;
      const vue = $table.wrap(`<div id="${id}"></div>`).wrap('<table-vue inline-template></table-vue>').wrap(`<div class="${CLASSES.WRAPPER}" />`).wrap($(`<div class="${CLASSES.WRAPPER_SCROLLER}" />`));
      const tb = new Vue({
        el: `#${id}`
      });
    });

  }
});
